import { ICON_PATHS, ICON_STROKE, type IconName } from '@antreja/ui/icons';

export type { IconName };

/**
 * Antreja UI-icoon (brandkit). Zonder `label` is het decoratief (aria-hidden) en hoort er zichtbare tekst naast;
 * met `label` krijgt het icoon zelf een toegankelijke naam.
 */
export function Icon({ name, size = 20, label, className }: { name: IconName; size?: number; label?: string; className?: string }) {
  return (
    <svg
      className={`icon ${className ?? ''}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={ICON_STROKE}
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable="false"
      {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true })}
    >
      <path d={ICON_PATHS[name]} />
    </svg>
  );
}
